module.exports = __webpack_public_path__ + "r-v3/img/coachmark_arrow_blue_03.2940100d.svg";